import { render, staticRenderFns } from "./SignComponent.vue?vue&type=template&id=8234bd2e&scoped=true&lang=pug&"
import script from "./SignComponent.vue?vue&type=script&lang=ts&"
export * from "./SignComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SignComponent.vue?vue&type=style&index=0&id=8234bd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8234bd2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
